module.exports = __webpack_public_path__ + "static/media/bless.751862a2.jpg";